import React, { forwardRef, useState, useImperativeHandle } from "react";
import './InputField.css';
import { TextField } from "@mui/material";
import InputMask from 'react-input-mask';

const InputField = forwardRef((props, ref) => {
    const { Mandatory, Label, Value, Disabled, OnUpdateValue, Mask, MaskChar, rows: Lines, type, endAdornment, onBlur } = props;

    const [currentValue, setCurrentValue] = useState(Value ? Value : "");
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useImperativeHandle(ref, () => ({
        Validate() {
            if (ValidateValue()) {
                SetNormalState();
                return true;
            } else {
                SetErrorState();
                return false;
            }
        },
        GetValue() {
            return currentValue;
        },
        SetValue(value) {
            setCurrentValue(value);
        },
        SetError(message)
        {
            SetErrorState(message);
        },
        ClearError()
        {
            SetNormalState();
        },
        GetError() {
            return errorMessage;
        },
        Clear() {
            setCurrentValue(""); 
        }
    }));

 function ValidateValue() {
        if (Mandatory) {

            if (!currentValue) return false;

            var check = currentValue+"";

            if (check.trim() == "") {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    function SetNormalState() {
        setError(false);
        setErrorMessage("");
    }

    function SetErrorState(message) {
        setError(true);
        setErrorMessage(message || "");
    }

    function Render() {
        if (Mask) {
            return (
                <div style={{display:"flex", flex:1}}>
                <InputMask
                    mask={Mask}
                    // MaskChar={null}: campos de tamanho variável (DDI) sem o "_" à vista
                    maskChar={MaskChar}
                    value={currentValue}
                    onChange={(e) => OnValueChangeHandler(e.target.value)}
                    onFocus={SetNormalState}
                    onBlur={onBlur}
                    disabled={Disabled}
                >
                    {(inputProps) => (
                        <TextField fullWidth
                            size="small"
                            type = {type}
                            label={Label}
                            {...inputProps}
                            required={Mandatory}
                            disabled={Disabled}
                            error={error}
                            helperText={errorMessage}
                            multiline={Lines > 1}
                            rows={Lines > 1 ? Lines : undefined}
                            InputProps={{
                                endAdornment: endAdornment,
                                style: { fontSize: '13px' }
                            }}
                            InputLabelProps={{
                                style: { fontSize: '13px' }
                            }}
                            sx={{
                                '& .MuiInputBase-root': {
                                    padding: '0px 6px'
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '3px'
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderWidth: '1px'
                                },
                                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#5A80FB !important',
                                    borderWidth: '1px !important'
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '13px'
                                },
                                '& .MuiInputLabel-shrink': {
                                    fontSize: '13px'
                                }
                            }}
                        />
                    )}
                </InputMask>
                </div>
            );
        } else {
            return (
                <div style={{display:"flex", flex:1}}>
                <TextField fullWidth
                    size="small"
                    type = {type}
                    label={Label}
                    value={currentValue}
                    onChange={(e) => OnValueChangeHandler(e.target.value)}
                    onFocus={SetNormalState}
                    onBlur={onBlur}
                    disabled={Disabled}
                    required={Mandatory}
                    error={error}
                    helperText={errorMessage}
                    multiline={Lines > 1}
                    rows={Lines > 1 ? Lines : undefined}
                    InputProps={{
                        endAdornment: endAdornment,
                        style: { fontSize: '13px' }
                    }}
                    InputLabelProps={{
                        style: { fontSize: '13px' }
                    }}
                    sx={{
                        '& .MuiInputBase-root': {
                            padding: '0px 6px'
                        },
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '3px'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px'
                        },
                        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#5A80FB !important',
                            borderWidth: '1px !important'
                        },
                        '& .MuiInputLabel-root': {
                            fontSize: '13px'
                        },
                        '& .MuiInputLabel-shrink': {
                            fontSize: '13px'
                        }
                    }}
                />
                </div>
            );
        }
    }

    function OnValueChangeHandler(value) {
        setCurrentValue(value);
        if (OnUpdateValue) OnUpdateValue(value);
    }

    return Render();
});

export default InputField;